/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface V1PausenzeitenPausenUeberpruefungenTrackerGet$Params {
}

export function v1PausenzeitenPausenUeberpruefungenTrackerGet(http: HttpClient, rootUrl: string, params?: V1PausenzeitenPausenUeberpruefungenTrackerGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, v1PausenzeitenPausenUeberpruefungenTrackerGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

v1PausenzeitenPausenUeberpruefungenTrackerGet.PATH = '/v1/pausenzeiten/pausenUeberpruefungenTracker';
